import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import {
  setCsfrToken as setCsfrTokenAction,
  loadApiToken as loadApiTokenAction,
} from 'spw-redux/modules/auth/actions';

interface IProps {
  setCsfrToken: (token: string) => void;
  loadApiToken: (token: string) => void;
}

const CsfrTokenFetcher: React.FC<IProps> = ({ setCsfrToken, loadApiToken }) => {
  React.useEffect(() => {
    const csfrToken = document.getElementById('csfr-token-container').innerText;
    setCsfrToken(csfrToken);
    loadApiToken(null);
  });
  return null;
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setCsfrToken: setCsfrTokenAction,
      loadApiToken: loadApiTokenAction,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(CsfrTokenFetcher);
